import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';

import {Survey} from '../../api/models/survey';
import {User} from '../../api/models/user';

import {AuthService} from '../../api/services/auth.service';
import {MessageService} from '../../api/services/message.service';
import {SurveyListComponent} from '../survey-list/survey-list/survey-list.component';
import {SurveyPreferencesComponent} from '../survey-list/survey-preferences/survey-preferences.component';
import {WaToastService} from "angular-awesome";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SurveyListComponent]
})
export class HomeComponent implements OnDestroy {

  private userSub: Subscription;

  //selectedSurvey: Survey | null = null;
  currentUser: User | null = null;
  preselectedSurveyId: number | null = null;

  constructor(private route: ActivatedRoute,
              private authService: AuthService,
              private toastService: WaToastService) {

    this.userSub = this.authService.loggedInUser$.subscribe({
      next: user => this.currentUser = user,
      error: err => {
        this.toastService.danger('Could not fetch current user.');
      }
    });

    // this.route.params.subscribe(params => {
    //   const surveyId = parseInt(params['id']);
    //   if (isNaN(surveyId)) return;
    //   this.preselectedSurveyId = surveyId;
    // });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }
}
